import { render, staticRenderFns } from "./B2bCustomers.vue?vue&type=template&id=af08893a&scoped=true&"
import script from "./B2bCustomers.vue?vue&type=script&lang=js&"
export * from "./B2bCustomers.vue?vue&type=script&lang=js&"
import style0 from "./B2bCustomers.vue?vue&type=style&index=0&id=af08893a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af08893a",
  null
  
)

export default component.exports